var path = 'areas/environments/proxies/views/index.html';
var html = "<script octo-section=tools type=text/ng-template> <a class='btn btn-success' href=\"#/environments/proxies/new\">Add proxy</a> </script> <div> <h3>Proxies</h3> <p>Octopus can talk to deployment targets through a proxy. Create proxies here and then configure each deployment target that needs a proxy.</p> <div class=\"octo-list-group narrow-left narrow650\"> <a class=octo-list-group-item href=#/environments/proxies/{{proxy.Id}} ng-repeat=\"proxy in proxies.Items\"> <h4 class=octo-list-group-item-heading>{{ proxy.Name }}</h4> </a> </div> <octo-paginator collection=proxies></octo-paginator> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/environments/proxies/views/index.html
// module id = 2128268221497117
// module chunks = 1